module.exports = __webpack_public_path__ + "static/fonts/iconfont.b170909.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.eot?t=1560845219567
// module id = 9tIM
// module chunks = 61